import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-FormProductoReactivoDinamico',
  templateUrl: './FormProductoReactivoDinamico.component.html',
  styleUrls: ['./FormProductoReactivoDinamico.component.css']
})
export class FormProductoReactivoDinamicoComponent implements OnInit {

  constructor(
    private fb: FormBuilder
  ) { }

  miFormulario: FormGroup = this.fb.group({
    nombre: [, [Validators.required, Validators.minLength(3)]],
    favoritos: this.fb.array(
      [
       [ 'GIS', Validators.required ],
       [ 'Mobiles', Validators.required],
       [ 'Serverless', Validators.required]  
      ], Validators.required
    )
  })

  get favoritosArr(){
    return this.miFormulario.get('favoritos') as FormArray;
  }

  ngOnInit() {
  }

  //validador
  campoEsValido( campo: string){
    return this.miFormulario.controls[campo].errors && 
           this.miFormulario.controls[campo].touched;
  }

  //guardar
  guardar(){
    //validar
    if (this.miFormulario.invalid){
      this.miFormulario.markAllAsTouched;
      return;
    }

    //mostrar
    console.log(this.miFormulario.value)

    //limpiar
    this.miFormulario.reset();
  }
}
